import { FaFileUpload } from 'react-icons/fa';
import { Button, Icon, Text } from '@/ui';

type Props = {
  isDisabled?: boolean;
};

export const FileDropzone = ({ isDisabled }: Props) => {
  return (
    <>
      <Icon as={FaFileUpload} boxSize="64px" color="gray.400" />
      <Text mt="4">
        <Button
          as="span"
          colorScheme="dark"
          data-testid="dropzone-button-file"
          fontSize="md"
          isDisabled={isDisabled}
          textDecor="underline"
          variant="link"
        >
          Choose a file
        </Button>{' '}
        or drag one here
      </Text>
    </>
  );
};

export const ImageDropzone = ({ isDisabled }: Props) => {
  return (
    <>
      <Icon color="gray.400" icon="Image" size="64px" />
      <Text mt="4">
        <Button
          as="span"
          colorScheme="dark"
          data-testid="dropzone-button-file"
          fontSize="md"
          isDisabled={isDisabled}
          textDecor="underline"
          variant="link"
        >
          Choose an image
        </Button>{' '}
        or drag one here
      </Text>
    </>
  );
};
